module.exports = __webpack_public_path__ + "static/media/info-1.ad17099f.png";